import React from 'react'
import { hasPermission } from 'services/permission'
import { Icon } from 'antd'
export interface IProps {
	width?: number
	actionCode?: string
	type?: string // 'primary' | 'default' | 'dangerous'
	action?: () => void
	icon?: string
	title?: string
	className?: any
}
export default class extends React.Component<IProps> {
	renderButton = () => {
		if (!hasPermission(this.props.actionCode)) return <React.Fragment />
		return (
			<span
				className={`app-button ${this.props.className || ''}`}
				data-type={this.props.type || 'default'}
				style={{ width: this.props.width || 100 }}
				onClick={() => {
					this.props.action && this.props.action()
				}}
			>
				{this.props.icon ? <Icon type={this.props.icon} style={{ marginRight: 10 }} /> : null}
				{this.props.title || ''}
			</span>
		)
	}

	render() {
		return this.renderButton()
	}
}



// WEBPACK FOOTER //
// ./src/components/AppAction/AppAction.tsx